import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormArray,
  Validators,
  AbstractControl,
} from "@angular/forms";
export enum ComponentType {
  Text = "text",
  Table = "table",
  Bool = "boolean",
  Number = "number",
  Date = "date",
  DateTime = "datetime",
  Select = "select",
  Button = "button",
  MatAutoComplete = "matAutoComplete",
  Textarea = "textarea",
  ListMatTableServerSide = "listMatTableServerSide",
  Divider = "divider",
  /** Barre de boutons actions */
  Actions = "actions",
  Menu = "menu",
  Card = "card",
  Iframe = "iframe",
  Video = "video",
  List = "list",
  Image = "image",
  /** Utilisés par edit-model component */
  Tab = "tab",
  Separator = "separator",
  /** pour insérer un espace vide */
  Gap = "gap",
  ImageList = "imageList",
}
/** tri par orderOnInstance.
 * Note:   obj1.orderOnInstance || 99999 au cas ou on a display onInstance mais pas orderOnInstance = undefined
 * Cependant on est obligé de tester orderOnInstance === 0 car 0 || 999999 renvoie 999999. 0 doit être interprété comme false par js je pense (même si il est typé number) */
export const preprocessModelDefinition = (modelDefinition: any) => {
  modelDefinition.properties = modelDefinition.properties.sort(
    (obj1, obj2) =>
      (obj1.orderOnInstance === 0
        ? obj1.orderOnInstance
        : obj1.orderOnInstance || 99999) -
      (obj2.orderOnInstance === 0
        ? obj2.orderOnInstance
        : obj2.orderOnInstance || 99999)
  );
  return modelDefinition;
};

export const generateFormControls = (
  modelDefinition,
  instanceCount,
  preprocess,
  noRequired
): any => {
  if (preprocess) {
    modelDefinition = preprocessModelDefinition(modelDefinition);
  }

  const formGroup = {};
  modelDefinition.properties.forEach((prop) => {
    const validators = (prop.validators || [])
      .map((validator) => {
        const { name, value } = validator;
        const ret = value ? Validators[name](value) : Validators[name];
        if (!noRequired || (noRequired && validator.name !== "required")) {
          return ret;
        }
      })
      .filter((value) => value !== undefined);

    if (prop.type === "table") {
      const arraySize = instanceCount[prop.name] || 1;
      formGroup[prop.name] = new UntypedFormArray(
        new Array(arraySize)
          .fill("")
          .map(
            (_) =>
              new UntypedFormGroup(
                generateFormControls(prop, null, preprocess, noRequired)
              )
          )
      );
    } else if (
      prop.type !== ComponentType.Divider &&
      prop.type !== ComponentType.Actions &&
      prop.type !== ComponentType.Card &&
      prop.type !== ComponentType.Iframe &&
      prop.type !== ComponentType.Video &&
      prop.type !== ComponentType.List &&
      prop.type !== ComponentType.Button &&
      prop.type !== ComponentType.Gap &&
      prop.type !== ComponentType.Image
    ) {
      // if (prop.name==="DateMaj") {
      //   debugger;
      // }
      formGroup[prop.name] = new UntypedFormControl(
        {
          value: null,
          // disabled: !!prop.disabled
        },
        validators
      );
    }
  });

  return formGroup;
};
/**
 * generate FormGroup From ModelDefinition
 * @param modelDefinition
 * @param instanceCount
 * @param preprocess
 * @param noRequired false by default. if true Validator required is bypassed. Used in searchComponent
 */
export const generateFormGroupFromModelDefinition = (
  modelDefinition,
  instanceCount,
  preprocess = false,
  noRequired = false
): UntypedFormGroup => {
  const formGroup = generateFormControls(
    modelDefinition,
    instanceCount,
    preprocess,
    noRequired
  );
  return new UntypedFormGroup(formGroup);
};
